import * as _ from 'underscore';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { DataTableComponent } from '../datatable/datatable.component';
import * as jQuery from 'jquery';

@Component({
	selector: 'app-email-link-summary-r13',
	templateUrl: './email-link-summary-r13.component.html',
	styleUrls: ['./email-link-summary-r13.component.css']
})
export class EmailLinkSummaryR13Component extends DataTableComponent implements OnInit {
	@Input() downloadconfig: any;
	@Input() downloadcsvcolumns: any;
	@Input() sectionclass: any;
	@Input() defaultsort: string;
	@Input() sectiontitle: string;
	@Input() columnsconfig: any;

	public key: string;
	public columns: any;
	showLoad = false;
	public hasData: boolean;
	public linkSummaryDetails: [];
	public reloadSubscription;
	public widgetDataSubscription;
	public downloadConfiguration: DownloadConfig;
	public downloadCSVColumns;

	public cssClasses: any = {
		pagerLeftArrow: '',
		pagerRightArrow: '',
		pagerNext: 'datatable-last-text',
		pagerPrevious: 'datatable-first-text',
		sortAscending: 'fa fa-long-arrow-up',
		sortDescending: 'fa fa-long-arrow-down'
	};

	public tooltipOptions = {
		animation: 'fade',
		arrow: true,
		duration: 750,
		dynamicTitle: true,
		position: 'top',
		scale: 'big'
	};

	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService, analyticsDataModel);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.columns = JSON.parse(decodeURI(this.columnsconfig));
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.downloadCSVColumns = JSON.parse(decodeURI(this.downloadcsvcolumns));
		this.requestData();
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService
			.processWidgetRequest(this.key, this.columns)
			.subscribe((response: any) => {
				this.showLoad = false;
				if (response.success && response.data && response.data.length > 0) {
					this.hasData = true;
					this.processResponseData(response.data);
				} else {
					this.hasData = false;
					this.linkSummaryDetails = [];
				}
			});
	}

	processResponseData(response: any): void {
		this.linkSummaryDetails = response;
		setTimeout(() => {
			jQuery('.linkSummaryClicksHeader').addClass('sort-active');
			jQuery('.linkSummaryClicksHeader .sort-btn').addClass('fa fa-long-arrow-down');
		}, 500);
	}
}
